<template>
  <v-list dense>
    <template>
      <v-list-item link to="/admin/crawler/config">
        <v-list-item-action><v-icon>mdi-spider-thread</v-icon></v-list-item-action>
        <v-list-item-content><v-list-item-title>Configuration du Crawler</v-list-item-title></v-list-item-content>
      </v-list-item>

      <v-list-item link to="/admin/multi-proxy/router">
        <v-list-item-action><v-icon>mdi-arrow-decision</v-icon></v-list-item-action>
        <v-list-item-content><v-list-item-title>État du Routeur</v-list-item-title></v-list-item-content>
      </v-list-item>

      <v-list-group :value="false" prepend-icon="mdi-open-in-new">
        <template v-slot:activator>
          <v-list-item-title>Outils</v-list-item-title>
        </template>

        <v-list-item link :href="getRayngunUrl()" target="_blank">
          <v-list-item-title>Erreurs (Raygun)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-bug</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getForgeUrl()" target="_blank">
          <v-list-item-title>Infrastructure (Forge)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-server-network</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getGitHubUrl()" target="_blank">
          <v-list-item-title>Code Source (Github)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-github</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getPm2Url()" target="_blank">
          <v-list-item-title>Processus Node (PM2)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-menu</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getHorizonUrl()" target="_blank">
          <v-list-item-title>Tâches (Horizon)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getForgeUrl()" target="_blank">
          <v-list-item-title>Serveurs (Vultr)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-server</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item link :href="getPapertailUrl()" target="_blank">
          <v-list-item-title>Logs (Papertail)</v-list-item-title>
          <v-list-item-icon><v-icon>mdi-text</v-icon></v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'AppNavigationTechnical',
  methods: {
    getHorizonUrl() {
      return process.env.VUE_APP_API.replace('api.check-position', 'seo-metatool') + 'authenticate?token=' + this.$account.token + '&go=/horizon'
    },
    getPapertailUrl() {
      return 'https://my.papertrailapp.com/systems/seo-metatool/events'
    },
    getGitHubUrl() {
      return 'https://github.com/seo-metatool/'
    },
    getRayngunUrl() {
      return 'https://app.raygun.com/'
    },
    getForgeUrl() {
      return 'https://forge.laravel.com/servers';
    },
    getPm2Url() {
      return 'https://app.pm2.io/bucket/5fae69749349da3a48297ca9/backend/overview/servers'
    }
  }
}
</script>

<style scoped>

</style>

